/* eslint-disable react-hooks/exhaustive-deps */
import classNames from 'classnames';
import { DropDown, HideField } from 'components/InputsMex/inputs';
import { SimpleWrapper } from 'containers/Pymes/componentes/contenedores';
import { PresuscritoGeneral } from 'containers/Pymes/constantes/general';
import useCustomToast from 'hooks/useCustomToasts';
import useUsuario from 'hooks/useUsuario';
import React, { useEffect, useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';

const InformacionAgente = ({
  name = 'agente',
  programas = {},
  options = [],
  border = true,
  className,
  codProd = 'default'
}) => {

  const [programasToShow, setProgramasToShow] = useState(programas);
  const methods = useFormContext();

  const { userIsLoggedIn, tipoUsuario } = useUsuario();

  const { addWarningToast } = useCustomToast();

  const agenteSeleccionado = methods.watch(name);

  useEffect(() => {
    loadProgramas(agenteSeleccionado);
  }, [agenteSeleccionado])

  const mappedOptions = useMemo(
    () => options?.map((item) => ({ label: item.label, value: item })),
    [options],
  );

  const loadProgramas = (value) => {
    if (Object.keys(programas).length > 0) {
      setProgramasToShow(programas[value?.codigoAgente]?.map((item) => ({ label: item.proNombre, value: item })));
    }
  }

  const AGENTE_RULES = useMemo(
    () => ({
      validarAcceso: (value) => {
        if (value?.acceso === false) {
          addWarningToast(value.mensaje);
          return value.mensaje;
        }
        return true;
      },
    }),
    [],
  );
  if ((tipoUsuario === 'cliente' || !userIsLoggedIn || options?.length === 1) && codProd === 'default') {
    return (
      <HideField
        show={false}
        name={name}
        defaultValue={options?.[0]}
        rules={{ validate: AGENTE_RULES }}
      />
    );
  }


  return (
    <div className="row">
      <div
        className={classNames('col-12 py-4', className, {
          'card-login-mex': border,
        })}
      >
        <div className="container-accidentes">
          <h3 className="font-mex" style={{ fontSize: '30px' }}>
            Información del agente
          </h3>
        </div>
        <div className="form-group">
          <SimpleWrapper
            name={name}
            label="Seleccione una clave de agente para cotizar"
          >
            <DropDown
              name={name}
              options={mappedOptions}
              rules={{
                required: 'Este campo es obligatorio',
                validate: AGENTE_RULES,
              }}
            />
          </SimpleWrapper>
        </div>

        {Object.keys(programas).length > 0 && codProd !== PresuscritoGeneral.prodCodigoCore && <div className="form-group">
          <SimpleWrapper
            name='carProgramaSeleccionado'
            label="Seleccione una programa de agente"
          >
            <DropDown
              name='carProgramaSeleccionado'
              options={programasToShow}
              rules={{
                required: 'Este campo es obligatorio',
              }}
            />
          </SimpleWrapper>
        </div>}
      </div>
    </div>
  );
};

export default InformacionAgente;
